<template>
  <Transition name="nested" mode="out-in" :duration="550">
    <slot></slot>
  </Transition>
</template>

<style>
/* parent */
.nested-enter-from,
.nested-leave-to {
  opacity: 0;
}

.nested-enter-active,
.nested-leave-active {
  transition: all 200ms ease-in-out;
}

.nested-leave-active {
  transition-delay: 200ms;
}

/* child */
.nested-enter-from .inner,
.nested-leave-to .inner {
  transform: translateX(100%);
}

.nested-enter-active .inner,
.nested-leave-active .inner {
  transition: all 200ms ease-in-out;
}

.nested-enter-active .inner {
  transition-delay: 200ms;
}
</style>
